export default {
      id: "prevPage-usage",
      viewBox: "0 0 21 14",
      url: __webpack_public_path__ + "img/icons.f759dcb6.svg#prevPage",
      toString: function () {
        return this.url;
      }
    }